import { MeiliSearch } from "meilisearch"

// B2C client — used for categories and collections queries
const client = new MeiliSearch({
  host: process.env.NEXT_PUBLIC_MEILISEARCH_HOST || "http://127.0.0.1:7700",
  apiKey: process.env.NEXT_PUBLIC_MEILISEARCH_API_KEY || "",
})

// Unified client — used for product search (queries products_unified on B2B Meilisearch).
// Falls back to B2C client config when the unified env vars are not set.
const unifiedClient = new MeiliSearch({
  host:
    process.env.NEXT_PUBLIC_MEILISEARCH_UNIFIED_HOST ||
    process.env.NEXT_PUBLIC_MEILISEARCH_HOST ||
    "http://127.0.0.1:7700",
  apiKey:
    process.env.NEXT_PUBLIC_MEILISEARCH_UNIFIED_API_KEY ||
    process.env.NEXT_PUBLIC_MEILISEARCH_API_KEY ||
    "",
})

// Index name for unified product search.
// When NEXT_PUBLIC_MEILISEARCH_UNIFIED_HOST is set, we query "products_unified".
// Otherwise fall back to "products" for backward compatibility.
const UNIFIED_PRODUCTS_INDEX = process.env.NEXT_PUBLIC_MEILISEARCH_UNIFIED_HOST
  ? "products_unified"
  : "products"

export default client
export { unifiedClient, UNIFIED_PRODUCTS_INDEX }
